import { Typography } from '@mui/material'
import React from 'react'
import ProgressSteps from './progress-steps'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(
  ({ palette, typography, spacing, breakpoints }) => ({
    heading: {
      ...typography.heading.h3,
      fontWeight: typography.fontWeightBold,
      color: palette.grey.shade[100],
      marginBottom: spacing(7),
      [breakpoints.down('sm')]: {
        marginBottom: spacing(4)
      }
    }
  })
)

const StepHeader = () => {
  const classes = useStyles()
  return (
    <>
      <Typography component='h1' className={classes.heading}>
        Cancel Subscription
      </Typography>
      <ProgressSteps />
    </>
  )
}

export default StepHeader
